import { motion } from "framer-motion";

const EASE = [0.33, 1, 0.68, 1];

export const MaskedLine = ({ children, delay = 0, className = "", innerClassName = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className={`block ${innerClassName}`}
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const FadeIn = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <p className={`uppercase tracking-[0.25em] text-xs text-ember font-body ${className}`}>{children}</p>
);
